import { Injectable } from '@angular/core';
import { UrlHelperService } from '../Common/urlhelper.service';
import { ApiService } from '../Common/api.service';


@Injectable({
  providedIn: 'root'
})
export class ContentService {
 
  constructor(private _api: ApiService) { 
   
  }

  GetPageContent(id:number)
  {
    return this._api.get(UrlHelperService.contentGetPageByMenuId+'/'+id);
  }

  SelectedCustomForm(id:number)
  {
    return this._api.get(UrlHelperService.SelectedCustomFormbypage+'/'+id);
  }
}
